import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@talentech/components";
// @ts-expect-error
import { INavigationMenuResponse } from "@talentech/components/build/storybook-core/components/Sidebar/SidebarTypes.d";

export const navigationApi = createApi({
  reducerPath: "navigation",
  baseQuery: axiosBaseQuery({ baseUrl: process.env.API_URL as string }),
  endpoints: (builder) => ({
    getApps: builder.query<INavigationMenuResponse, Record<string, any>>({
      query: (params) => ({
        url: `/user/apps`,
        params,
      }),
    }),
    getTenants: builder.query<{tenants?: any[]}, Record<string, any>>({
      query: (params) => ({
        url: `/user/tenants`,
        params,
      }),
    }),
    
  }),
});

export const { useGetAppsQuery, useGetTenantsQuery } = navigationApi;
